export const COMPANY_USERS_DEFAULT_SORT = {
  sortedColumn: 'firstName',
  sortedColumnOrder: 'ascend'
}

export const COMPANY_USERS_STATUSES = [
  {
    key: 0,
    value: null,
    title: 'All',
    label: 'All'
  },
  {
    key: 1,
    value: 1,
    title: 'Active',
    label: 'Active'
  },
  {
    key: 2,
    value: 0,
    title: 'Inactive',
    label: 'Inactive'
  },
  {
    key: 3,
    value: 3,
    title: 'Pending',
    label: 'Pending'
  }
]

export const COMPANY_USERS_STATUS = [
  {
    label: 'Active',
    value: true
  },
  {
    label: 'Inactive',
    value: false
  }
]

export const COMPANY_USERS_CREATION_TYPES = [
  {
    key: 1,
    value: 1,
    title: "Don't allow"
  },
  {
    key: 2,
    value: 2,
    title: 'Pending status to approve'
  },
  {
    key: 3,
    value: 3,
    title: 'Create without pending'
  }
]
